<template>
  <div class="number-bd clear">
    <span :class="[{'reduce': type === 'default'},{'reduce-round': type === 'round'},{'disabled': disabledMin}]" @click="reduce()">
       <i class="iconfont icon-reduce"></i>
    </span>
    <span :class="[{'number': type === 'default'},{'number-round': type === 'round'}]" :style="{width: width}">{{currentValue}}</span>
    <span :class="[{'add': type === 'default'},{'add-round': type === 'round'},{'disabled': disabledMax}]" @click="add()">
        <i class="iconfont icon-add"></i>
    </span>
  </div>
</template>
<script>
/**
 * @param min [Number]  最小值，默认不限制
 * @param max [Number]  最大值，默认不限制
 * @param type [String] 显示类型default(默认)，round(圆形)
 * @param value [String] 绑定v-model的值
 * @param width [String] 显示数量的宽度
 * @param change [Function] 变更触发事件
 * @describe
 *
 * @example
 *
  <t-number :min="1" v-model="" @change=""></t-number>
 */

export default {
  name: 'tNumber',
  props: {
    min: Number, // 最小值
    max: Number, // 最大值
    type: {
      type: String,
      default: 'default',
    },
    value: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: '36px',
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
  },
  computed: {
    disabledMin() {
      return typeof this.min === 'undefined' ? false : (this.currentValue || 0) <= this.min;
    },
    disabledMax() {
      return typeof this.max === 'undefined' ? false : (this.currentValue || 0) >= this.max;
    },
  },
  methods: {
    add() {
      if (!this.disabledMax) {
        this.currentValue++;
        this.$emit('input', this.currentValue);
        this.$emit('change', this.currentValue);
      }
    },
    reduce() {
      if (!this.disabledMin) {
        this.currentValue--;
        this.$emit('input', this.currentValue);
        this.$emit('change', this.currentValue);
      }
    },
  },
};

</script>
<style lang="scss">
.number-bd {
  .reduce {
    height: 28px;
    width: 28px;
    line-height: 26px;
    text-align: center;
    float: left;
    border-radius: 2px 0 0 2px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    border-left: 1px solid #eee;
    background-color: #fafafa;
    i {
      color: #404040;
      font-size: 14px;
    }
    &.disabled i {
      color: #ccc !important
    }
  }
  .reduce-round {
    display: block;
    text-align: center;
    height: 28px;
    width: 28px;
    line-height: 26px;
    float: left;
    border-radius: 14px;
    border: 1px solid #ccc;
    i {
      color: #404040;
      font-size: 14px;
    }
    &.disabled {
      border: 1px solid #eee;
      i {
        color: #ccc;
      }
    }
  }
  .number {
    color: #333;
    float: left;
    padding: 0 4px;
    height: 28px;
    line-height: 26px;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    border-left: 1px solid rgba(238, 238, 238, 0.6);
    border-right: 1px solid rgba(238, 238, 238, 0.6);
  }
  .number-round {
    float: left;
    color: #333;
    height: 28px;
    line-height: 26px;
    padding: 0 4px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .add {
    float: left;
    height: 28px;
    width: 28px;
    line-height: 26px;
    text-align: center;
    border-radius: 0 2px 2px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    background-color: #fafafa;
    i {
      color: #404040;
      font-size: 14px;
    }
    &.disabled {
      color: #ccc !important
    }
  }
  .add-round {
    height: 28px;
    width: 28px;
    line-height: 26px;
    float: left;
    border-radius: 14px;
    border: 1px solid #ccc;
    text-align: center;
    i {
      color: #404040;
      font-size: 14px;
    }
    &.disabled {
      border: 1px solid #eee;
      i {
        color: #ccc;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/number.vue